export const opportunitySummarySelector = ({ activeIds, entities, stipulations }) => ({
  activeOpportunityId: activeIds.opportunityId,
  forgivenessVersion: entities.loanForgiveness.byId[activeIds.forgivenessId]?.applicationVersionSelected,
  opportunity: entities.opportunities.byId[activeIds.opportunityId],
  stipulations: stipulations.allStipulations,
});
